import { Component, DestroyRef, OnInit, inject} from '@angular/core';
import { httpsCallable } from 'firebase/functions';
import { RenderListComponent } from '../render-list/render-list.component';
import { FirebaseFirestoreService } from '../../services/firebase-firestore.service';
import { FirebaseRenderData } from '../../services/firebase.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { BaseState } from '../../reducers';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FirebaseFunctionService } from '../../services/firebase-function.service';

@Component({
  selector: 'app-render-page',
  standalone: true,
  imports: [RenderListComponent, AsyncPipe, RouterOutlet],
  templateUrl: './render-page.component.html',
  styles: ``
})
export class RenderPageComponent implements OnInit {
  renderList: FirebaseRenderData[] | null | undefined = null
  renderPipelineId = this.store.select(state => state.user?.openRenderPipelineId)
  functions = inject(FirebaseFunctionService)

  destroy = inject(DestroyRef)

  constructor(
    private firestoreService: FirebaseFirestoreService,
    private store: Store<BaseState>
  ){
  }

  ngOnInit(): void {
    setTimeout(() =>
      this.firestoreService.getRenderListPipe().pipe(takeUntilDestroyed(this.destroy)).subscribe((data) => {
        this.renderList = data.docs.map(x => x.data() as FirebaseRenderData)
      }), 300
    )
  }

  async onClicked() {
    await httpsCallable(this.functions.functions, 'createRenderGroup')()
    console.log("Testing")
  }
}
